import clsx from 'clsx';
import styles from './base-input-wrapper.module.css';
import { ReactNode } from 'react';
import { InputMask } from '@react-input/mask';
import { PHONE_MASK_CONFIG, US_PHONE_COUNTRY_CODE } from '@/util/constants';
import { BaseInputWrapper } from './base-input-wrapper';

interface PhoneInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'placeholder' | 'type'
> {
  name: string;
  label?: ReactNode;
  withIconsIndicators?: boolean;
  description?: string;
  readersOnlyLabel?: boolean;
}
export function PhoneInput({
  name,
  label,
  className,
  withIconsIndicators = true,
  description,
  id,
  readersOnlyLabel = false,
  ...restProps
}: PhoneInputProps) {
  return (
    <BaseInputWrapper
      id={id}
      name={name}
      label={label}
      className={className}
      withIconsIndicators={withIconsIndicators}
      description={description}
      readersOnlyLabel={readersOnlyLabel}
      restProps={restProps}
    >
      {({ fieldProps, hasError, showSuccess, inputClassName, htmlFor }) => (
        <>
          <InputMask
            id={htmlFor}
            {...PHONE_MASK_CONFIG}
            placeholder="XXX-XXX-XXXX"
            className={inputClassName}
            type="tel"
            {...fieldProps}
          />
          <div
            className={clsx(
              styles.flagContainer,
              hasError && styles.hasError,
              showSuccess && styles.hasSuccess,
            )}
          >
            <img src="/flag-us.svg" alt="" />
            <span>{US_PHONE_COUNTRY_CODE}</span>
          </div>
        </>
      )}
    </BaseInputWrapper>
  );
}
